import { createContext } from 'react';
import { PageHeaderDefaultProps } from "./constants";
export var PageHeaderContext = /*#__PURE__*/createContext({
  colorScheme: PageHeaderDefaultProps.colorScheme
});
PageHeaderContext.displayName = 'PageHeaderContext';